var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMinimalX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e8887ee3-eec8-4201-a621-2a42172d961f",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.72 53.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95{fill:#1f2c3c;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-265a87f5-c8dc-45b9-be51-3e614e258f3d"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 56.68,
    cy: 5.04,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 56.68,
    cy: 19.46,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 56.68,
    cy: 33.89,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 56.68,
    cy: 48.31,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 39.47,
    cy: 5.04,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 39.47,
    cy: 19.46,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 39.47,
    cy: 33.89,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 39.47,
    cy: 48.31,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 22.25,
    cy: 19.46,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 22.25,
    cy: 33.89,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 5.04,
    cy: 19.46,
    r: 5.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1f97e3a7-07aa-4dd4-a2a4-07a5693a4a95",
    cx: 5.04,
    cy: 33.89,
    r: 5.04
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinimalX);
export default __webpack_public_path__ + "static/media/logo-minimal-x.aef46b6fc4fb1e6ffa3e56a854dd6206.svg";
export { ForwardRef as ReactComponent };